(function () {
  const SECTION_ID = 'header-predictive-search';
  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 250;

  function debounce(fn, wait) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function initForm(form) {
    const input = form.querySelector('input[name="q"]');
    if (!input || form.dataset.hpsReady) return;
    form.dataset.hpsReady = 'true';

    const mobileArea = form.closest('.mobile-search-area');
    const mobileContainer = mobileArea && mobileArea.querySelector('.container-mdjhd');
    const wrapper = mobileContainer || form.closest('.ht-search-box-mdjhd') || form;

    const dropdown = document.createElement('div');
    if (mobileContainer) {
      dropdown.className = 'hps-mobile-results';
    } else {
      wrapper.classList.add('hps-wrapper');
      dropdown.className = 'hps-dropdown';
    }
    dropdown.hidden = true;
    wrapper.appendChild(dropdown);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');

    let controller = null;
    const cache = new Map();

    function open() {
      if (!dropdown.innerHTML.trim()) return;
      dropdown.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      dropdown.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function render(html) {
      dropdown.innerHTML = html;
      html.trim() ? open() : close();
    }

    function fetchResults(terms) {
      if (cache.has(terms)) {
        render(cache.get(terms));
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      const url =
        `${window.Theme.routes.predictive_search_url}?q=${encodeURIComponent(terms)}` +
        '&resources[type]=product' +
        '&resources[limit]=8' +
        `&section_id=${SECTION_ID}`;

      fetch(url, { signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const section = doc.getElementById(`shopify-section-${SECTION_ID}`);
          const html = section ? section.innerHTML : '';
          cache.set(terms, html);
          if (input.value.trim() === terms) render(html);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') close();
        });
    }

    const onInput = debounce(() => {
      const terms = input.value.trim();
      if (terms.length < MIN_CHARS) {
        if (controller) controller.abort();
        dropdown.innerHTML = '';
        close();
        return;
      }
      fetchResults(terms);
    }, DEBOUNCE_MS);

    input.addEventListener('input', onInput);
    input.addEventListener('focus', open);

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
      } else if (event.key === 'ArrowDown' && !dropdown.hidden) {
        const first = dropdown.querySelector('a');
        if (first) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    dropdown.addEventListener('keydown', (event) => {
      const links = Array.from(dropdown.querySelectorAll('a'));
      const index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' && index < links.length - 1) {
        event.preventDefault();
        links[index + 1].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        index > 0 ? links[index - 1].focus() : input.focus();
      } else if (event.key === 'Escape') {
        close();
        input.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) close();
    });
  }

  function init() {
    document.querySelectorAll('form.hts-box-inner-mdjhd').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
